export interface ErrorProps extends Error {
	status?: number;
	code?: string;
}

export interface Category {
	id?: number;
	external_id: string;
	name: string;
	slug: string;
}

export interface Product {
	id?: number;
	external_id: string;
	name: string;
	slug: string;
	image_url: string | null;
}

export interface SpecificPage {
	id?: number;
	url: string;
}

export interface SettingsTabProps {
	onSave: () => void;
}

export interface ConfigDataResponse extends Response {
	data?: ConfigData;
	message?: string;
}

export type BackgroundUploadRes = {
	background: {
		background_image: string | null;
		original_image_name: string | null;
	};
};

export interface ConfigData {
	enable_timer: boolean;
	name: string;
	priority: number;
	timer_type: TimerType;
	display_at: string;
	categories: Category[];
	specificPages: SpecificPage[];
	products: Product[];
	countdown_mode: string;
	from_date?: string; // Date in ISO format
	to_date?: string; // Date in ISO format
	time_frame_type: string;
	time_frame_value?: number;
	interactivity: string;
	url?: string;
	title: string;
	subtitle: string;
	show_days: boolean;
	days_label: string;
	show_hours: boolean;
	hours_label: string;
	show_minutes: boolean;
	minutes_label: string;
	show_seconds: boolean;
	seconds_label: string;
	button_text: string;
	font: string;
	background_color: string;
	timer_window_color: string;
	countdown_color: string;
	time_units_color: string;
	title_font_style: string;
	subtitle_font_style: string;
	button_bg_color: string;
	button_text_color: string;
	text_alignment: TextAlignment;
	timer_mode: TimerMode;
	countdown_position: CountdownPosition;
	sticky_timer: boolean;
	/** Null for a timer created before templates existed. */
	template_id: string | null;
	background_image: string | null;
	original_image_name: string | null;
	mobile_use_desktop_settings: boolean;
	/** Null while the mobile view follows the desktop settings. */
	mobile_appearance: AppearanceConfig | null;
}

/** The settings that can differ between the desktop and the mobile view; the rest of the timer is shared. */
export type AppearanceConfig = Pick<
	ConfigData,
	| 'text_alignment'
	| 'font'
	| 'background_image'
	| 'original_image_name'
	| 'background_color'
	| 'timer_window_color'
	| 'countdown_color'
	| 'time_units_color'
	| 'title_font_style'
	| 'subtitle_font_style'
	| 'button_bg_color'
	| 'button_text_color'
>;

export enum TextAlignment {
	LEFT = 'LEFT',
	CENTER = 'CENTER',
	RIGHT = 'RIGHT',
}

export enum TimerType {
	BAR = 'BAR',
	PRODUCT_CONTAINER = 'PRODUCT_CONTAINER',
}

export enum TimerMode {
	HIDE = 'HIDE',
	RESTART = 'RESTART',
}

export enum CountdownPosition {
	RIGHT_OF_TITLE = 'RIGHT_OF_TITLE',
	LEFT_OF_TITLE = 'LEFT_OF_TITLE',
	ABOVE_TITLE = 'ABOVE_TITLE',
	BELOW_TITLE = 'BELOW_TITLE',
}

export type GridConfig = ConfigData & {
	id: number;
};

export interface GridResponse {
	data?: GridConfig[];
	message?: string;
}

export enum Route {
	EDIT = 'EDIT',
	CREATE = 'CREATE',
}

export enum StartToFinishDateRangeSaveIssue {
	MISSING = 'missing',
	UNPARSABLE = 'unparsable',
	ERROR = 'error',
}

export enum StartToFinishDateRangeErrorMessage {
	REQUIRED = 'This is a required field.',
	MISSING_RANGE = 'Both dates are required and must be valid.',
	UNPARSABLE = 'Please fill out this field.',
	ERROR = 'Date and time must be in the future.',
}
